import React, { useEffect, useState } from 'react';

const PersonalizedStrategyCard = () => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimate(true);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  const strategies = [
    { icon: '⏱️', label: 'Timeline Analysis', detail: 'Short & Long Term' },
    { icon: '⚖️', label: 'Risk Assessment', detail: 'Tolerance Matching' },
    { icon: '🎯', label: 'Goal Alignment', detail: 'Priority Based' }
  ];

  return (
    <div className="bg-white rounded-xl shadow-md p-4 sm:p-6 h-full flex flex-col">
      {/* Header - More compact */}
      <div className={`mb-3 sm:mb-4 transition-all duration-800 ${
        animate ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'
      }`}>
        <h3 className="text-base sm:text-lg lg:text-xl font-semibold text-[#113262] mb-1 sm:mb-2 leading-tight">
          Get personalized investment strategy
        </h3>
        <p className="text-xs sm:text-sm text-[#545454] leading-relaxed">
          Our algorithms craft a goal-based strategy tailored to your timeline and risk tolerance.
        </p>
      </div>

      {/* Strategy Items - More compact */}
      <div className="grid grid-cols-1 gap-2 mb-3 flex-1">
        {strategies.map((strategy, index) => (
          <div
            key={index}
            className={`bg-gradient-to-r from-[#E8EEF6] to-[#A2B8D8] p-2 sm:p-3 rounded-lg flex items-center gap-2 sm:gap-3 border-2 border-transparent hover:border-[#1C52A0] transition-all duration-400 ${
              animate ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-6'
            }`}
            style={{ transitionDelay: `${200 + index * 200}ms` }}
          >
            <div className={`w-6 h-6 sm:w-8 sm:h-8 bg-gradient-to-br from-[#11326240] to-[#1C52A040] rounded-lg flex items-center justify-center text-[#113262] text-sm font-bold flex-shrink-0 transition-all duration-700 ${
              animate ? 'scale-100 rotate-0' : 'scale-0 -rotate-180'
            }`}
            style={{ transitionDelay: `${600 + index * 200}ms` }}>
              {strategy.icon}
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-xs sm:text-sm font-semibold text-[#113262] mb-0.5 truncate">
                {strategy.label}
              </h4>
              <p className="text-xs text-[#545454] font-medium">
                {strategy.detail}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* AI Algorithm Section - Much more compact */}
      <div className={`bg-gradient-to-br from-[#FEF5E7] to-[#FAD49D] p-2 sm:p-3 rounded-lg text-center transition-all duration-800 delay-800 ${
        animate ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
      }`}>
        <div className="flex items-center justify-center gap-2 mb-2">
          <div className="w-6 h-6 sm:w-8 sm:h-8 relative">
            {/* AI Circuit Icon */}
            <div className={`absolute inset-0 transition-all duration-1000 delay-1000 ${
              animate ? 'opacity-100' : 'opacity-0'
            }`}>
              <div className="w-full h-full bg-gradient-to-br from-[#113262] to-[#1C52A0] rounded-lg flex items-center justify-center">
                <svg className="w-4 h-4 sm:w-5 sm:h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2L2 7V10C2 16 6 20.9 12 22C18 20.9 22 16 22 10V7L12 2M12 4.3L19 8.2V10C19 15.1 15.9 19.1 12 20C8.1 19.1 5 15.1 5 10V8.2L12 4.3M12 6C10.9 6 10 6.9 10 8S10.9 10 12 10 14 9.1 14 8 13.1 6 12 6M12 12C10.9 12 10 12.9 10 14S10.9 16 12 16 14 15.1 14 14 13.1 12 12 12M8 9C7.4 9 7 9.4 7 10S7.4 11 8 11 9 10.6 9 10 8.6 9 8 9M16 9C15.4 9 15 9.4 15 10S15.4 11 16 11 17 10.6 17 10 16.6 9 16 9M8 15C7.4 15 7 15.4 7 16S7.4 17 8 17 9 16.6 9 16 8.6 15 8 15M16 15C15.4 15 15 15.4 15 16S15.4 17 16 17 17 16.6 17 16 16.6 15 16 15Z"/>
                </svg>
              </div>
            </div>
          </div>
          
          <div className="text-left">
            <h4 className="text-xs sm:text-sm font-semibold text-[#113262] leading-tight">
              AI Algorithm
            </h4>
            <p className="text-xs text-[#545454]">
              Smart optimization
            </p>
          </div>
        </div>
        
        <button onClick={() => window.location.href = "/ai-driven"} className={`bg-gradient-to-r from-[#F49611] to-[#F6A839] text-white px-3 py-1.5 rounded-lg text-xs font-semibold hover:scale-105 hover:shadow-lg transition-all duration-300 w-full ${
          animate ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}
        style={{ transitionDelay: '1400ms' }}>
          Get Strategy
        </button>
      </div>
    </div>
  );
};

export default PersonalizedStrategyCard;